/*
 * @Author: your name
 * @Date: 2022-02-18 11:51:59
 * @LastEditTime: 2022-02-18 12:22:13
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \jeecg-boot\ant-design-vue-jeecg\src\utils\qs.js
 */
import qs from 'qs'
export const getUrlValues = () => {
  const index = window.location.href.lastIndexOf('?')
  return qs.parse(window.location.href.slice(index + 1))
}
